/* eslint-disable vue/no-async-in-computed-properties */
import axios from 'axios';

export const lookup = {
  languages: [
    { id: 3100, name: 'English', code: 'EN' },
    { id: 3101, name: 'Spanish', code: 'SPA' },
    { id: 3102, name: 'Chinese', code: 'CHN' },
    { id: 3103, name: 'Korean', code: 'KOR' },
    { id: 3104, name: 'Vietnamese', code: 'VNM' },
    { id: 3105, name: 'Japanese', code: 'JPA' },
  ],

  states: [
    { state_code: 'AK', name: 'Alaska' },
    { state_code: 'AL', name: 'Alabama' },
    { state_code: 'AR', name: 'Arkansas' },
    { state_code: 'AS', name: 'American Samoa' },
    { state_code: 'AZ', name: 'Arizona' },
    { state_code: 'CA', name: 'California' },
    { state_code: 'CO', name: 'Colorado' },
    { state_code: 'CT', name: 'Connecticut' },
    { state_code: 'DC', name: 'Washington DC' },
    { state_code: 'DE', name: 'Delaware' },
    { state_code: 'FL', name: 'Florida' },
    { state_code: 'GA', name: 'Georgia' },
    { state_code: 'GU', name: 'Guam' },
    { state_code: 'HI', name: 'Hawaii' },
    { state_code: 'IA', name: 'Iowa' },
    { state_code: 'ID', name: 'Idaho' },
    { state_code: 'IL', name: 'Illinois' },
    { state_code: 'IN', name: 'Indiana' },
    { state_code: 'KS', name: 'Kansas' },
    { state_code: 'KY', name: 'Kentucky' },
    { state_code: 'LA', name: 'Louisiana' },
    { state_code: 'MA', name: 'Massachusetts' },
    { state_code: 'MD', name: 'Maryland' },
    { state_code: 'ME', name: 'Maine' },
    { state_code: 'MH', name: 'Marshall Island' },
    { state_code: 'MI', name: 'Michigan' },
    { state_code: 'MN', name: 'Minnesota' },
    { state_code: 'MO', name: 'Missouri' },
    { state_code: 'MS', name: 'Mississippi' },
    { state_code: 'MT', name: 'Montana' },
    { state_code: 'NC', name: 'North Carolina' },
    { state_code: 'ND', name: 'North Dakota' },
    { state_code: 'NE', name: 'Nebraska' },
    { state_code: 'NH', name: 'New Hampshire' },
    { state_code: 'NJ', name: 'New Jersey' },
    { state_code: 'NM', name: 'New Mexico' },
    { state_code: 'NV', name: 'Nevada' },
    { state_code: 'NY', name: 'New York' },
    { state_code: 'OH', name: 'Ohio' },
    { state_code: 'OK', name: 'Oklahoma' },
    { state_code: 'OR', name: 'Oregon' },
    { state_code: 'PA', name: 'Pennsylvania' },
    { state_code: 'PR', name: 'Puerto Rico' },
    { state_code: 'RI', name: 'Rhode Island' },
    { state_code: 'SC', name: 'South Carolina' },
    { state_code: 'SD', name: 'South Dakota' },
    { state_code: 'TN', name: 'Tennessee' },
    { state_code: 'TX', name: 'Texas' },
    { state_code: 'UT', name: 'Utah' },
    { state_code: 'VA', name: 'Virginia' },
    { state_code: 'VI', name: 'Virgin Islands' },
    { state_code: 'VT', name: 'Vermont' },
    { state_code: 'WA', name: 'Washington' },
    { state_code: 'WI', name: 'Wisconsin' },
    { state_code: 'WV', name: 'West Virginia' },
    { state_code: 'WY', name: 'Wyoming' },
  ],
  package_categories: [
    { id: 1000, name: 'ServSafe Certification' },
    { id: 1100, name: 'Alcohol Service Class' },
    { id: 1200, name: 'Prometric Certification' },
    { id: 1300, name: 'PFS Elearning' },
    { id: 2000, name: 'AB 1825 Supervisor Class' },
    { id: 2010, name: 'Sexual Harassment Prevention - Employee Class' },
    { id: 2100, name: 'Apex Elearning' },
    { id: 3000, name: 'Food Handler Class' },
  ],
  product_types: [
    { id: 3600, name: 'Fees' },
    { id: 3640, name: 'File' },
    { id: 3630, name: 'E-Learning Course' },
  ],

  computed: {
    async packages() {
      const packages = await axios.get('/api/packages');
      return packages.data.data;
    },
    async products() {
      const products = await axios.get('/api/products');
      return products.data;
    },
    async certificates() {
      const certificates = await axios.get('/api/certificates');
      return certificates.data;
    },
  },

  methods: {
    byID(obj, id) {
      return this[obj].find(e => e.id === id);
    },
  },
};
